// Third-party
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// Components
import { SecondaryNavigation } from '../../../components/navigation';
import { withErrorBoundary } from '../../../components/errors';

// Utils
import { formatMessage } from '../../../../utils/i18n';
import { userHasPermission, PERMISSIONS } from '../../../../utils/permissions';

// Actions
import { ReduxState } from '../../../../redux/modules/types';
import Nullable from '@/types/nullable';
import User from '@/types/user';

const SEARCH_TABS = {
  ALL: '/search',
  FUNDS: '/search/funds',
  SAVED_FUNDS: '/search/saved-funds',
  BENCHMARKS: '/search/benchmarks',
  SAVED_BENCHMARKS: '/search/saved-benchmarks',
};

type StateProps = {
  user?: Nullable<User>;
};

type Props = StateProps;

class FundScreenerNavigation extends Component<Props> {
  getTabOptions = () => {
    const { user } = this.props;

    const items = [
      {
        value: SEARCH_TABS.ALL,
        label: formatMessage('Search.Nav.All'),
        exact: true,
        subValues: [SEARCH_TABS.BENCHMARKS, SEARCH_TABS.FUNDS],
      },
      {
        value: SEARCH_TABS.SAVED_FUNDS,
        label: formatMessage('Search.Nav.SavedFunds'),
      },
      {
        value: SEARCH_TABS.SAVED_BENCHMARKS,
        label: formatMessage('Search.Nav.SavedBenchmarks'),
        hidden: !user || !userHasPermission(user, PERMISSIONS.BENCHMARKS),
      },
    ];

    return items.filter(i => !i.hidden);
  };

  render() {
    return <SecondaryNavigation className="navigation-pills" items={this.getTabOptions()} />;
  }
}

const mapStateToProps = (state: ReduxState): StateProps => ({
  user: state.auth.user,
});

export default withRouter(withErrorBoundary(connect(mapStateToProps)(FundScreenerNavigation)));
